import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button, Input, Divider, List, Typography } from "antd";
import {
    SearchOutlined,
    PlusOutlined
} from "@ant-design/icons";
import ModuleCardItem, { ModuleCardItemSkeleton } from "../Components/ModuleCardItem/ModuleCardItem";
import ContentFilterPopover from "./ContentFilters/ContentFilterPopover";

const { Text } = Typography;

const MyModules = ({ createdModules, loading = false, filterConfig }) => {
    const history = useHistory();
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => clearTimeout(timeout);
    }, [searchTerm]);
    const moduleSkeletonList = Array.from({ length: 4 }, (_, index) => ({ id: `module-skeleton-${index}` }));
    const filteredModules = useMemo(() => {
        const query = debouncedSearchTerm.trim().toLowerCase();
        if (!query) {
            return createdModules;
        }
        return (createdModules || []).filter((module) => {
            const moduleName = module?.name || "";
            const primaryAuthor = module?.primaryAuthor
                ? `${module.primaryAuthor.firstName || ""} ${module.primaryAuthor.lastName || ""}`.trim()
                : "";
            return `${moduleName} ${primaryAuthor}`.toLowerCase().includes(query);
        });
    }, [createdModules, debouncedSearchTerm]);

    return (
        <>
            {/* <Card className="my-content-content-card"> */}
            <div className="my-content-panel-head">
                <div className="my-content-panel-head-title">
                    <h3>My Modules</h3>
                    <Text className="my-content-panel-subtitle" type="secondary">
                        Browse and manage your uploaded module library
                    </Text>
                </div>
                <Divider style={{ margin: "0" }} />
                <div className="my-content-toolbar">
                    <Input
                        style={{ width: "30%" }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        prefix={<SearchOutlined />}
                        placeholder="Search modules..."
                    />
                    <ContentFilterPopover
                        content={filterConfig?.content}
                        selectedTags={filterConfig?.selectedTags || []}
                        onClear={filterConfig?.onClear}
                    />
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => history.push("/modules/create")}>
                        New Module
                    </Button>
                </div>
            </div>
            <List
                className="my-content-module-list"
                grid={{
                    gutter: [8, 8],
                    xs: 1,
                    sm: 1,
                    md: 1,
                    lg: 1,
                    xl: 1,
                    xxl: 1
                }}
                dataSource={loading ? moduleSkeletonList : filteredModules}
                pagination={{
                    pageSize: 4
                }}
                renderItem={(module, index) => (
                    <List.Item
                        key={module.id}
                        className="created-modules-list-item">
                        {loading ? (
                            <ModuleCardItemSkeleton index={index} />
                        ) : (
                            <Link
                                to={`/creator/created-modules/${module.id}`}
                                style={{ width: "100%" }}>
                                <ModuleCardItem
                                    module={module}
                                    index={index}
                                    searchTerm={debouncedSearchTerm}
                                // actionMenu={(
                                //     <CardMenuButton
                                //         className="module-card-item__menu-button"
                                //         items={[
                                //             {
                                //                 label: "View Module",
                                //                 key: "view-module",
                                //                 icon: <EyeOutlined />
                                //             }
                                //         ]}
                                //         onMenuClick={(key) => {
                                //             if (key === "view-module") {
                                //                 history.push(`/creator/created-modules/${module.id}`);
                                //             }
                                //         }}
                                //     />
                                // )}
                                />
                            </Link>
                        )}
                    </List.Item>
                )}
            />
            <Button type="link" className="my-content-create-link">
                <Link to="/modules/create">+ Create Module</Link>
            </Button>
            {/* </Card> */}
        </>
    );
};

export default MyModules;
